import { nipige_cap } from '@/services';
import Axios from "axios";


const resetUrlsByRole = {
    'Admin': '/users/admin/forgot-password',
     'Tenant': '/users/tenant/forgot-password',
    'Partner': '/users/partner/forgot-password'
}

const resetUpdateByRole = {
    'Admin': '/users/admin/reset-password',
     'Tenant': '/users/tenant/reset-password',
    'Partner': '/users/partner/reset-password'
}




export const sendResetPasswordRequest = async (payload,type) => {
    try {
        let result = await nipige_cap.post(resetUrlsByRole[type], payload);
        return result.data
    } catch (error) {
        throw new Error(error.response.data.message)
    }
}

export const resetPasswordConfirm = async (payload,type) => {
    try {
        let result = await nipige_cap.post(resetUpdateByRole[type], payload);
        return result.data
    } catch (error) {
        throw new Error(error.response.data.message)
    }
}




// const authUrlsByRole = {
//     'Admin': '/users/admin/login',
//     'Tenant': '/users/tenant/login',
//     'Partner': '/users/partner/login'
// }